import { Reveal, SectionTag, CtaButton } from "./shared";
import { Check } from "lucide-react";

export const Investment = () => (
  <section id="investment" className="py-12 lg:py-16 bg-white" data-testid="investment-section">
    <div className="max-w-[1320px] mx-auto px-6 lg:px-10">
      <SectionTag num="07" label="The Investment" />
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Reveal>
            <h2 className="font-display font-extrabold text-[#0B1B2B] tracking-[-0.03em] leading-[0.98] text-5xl sm:text-6xl lg:text-[84px]">
              $25,000<span className="text-[#0E5F46]">.</span>
            </h2>
            <p className="mt-3 font-display font-bold text-[#0B1B2B]/70 text-xl">Per company. Fixed. Agreed before we start.</p>
          </Reveal>
          <Reveal delay={0.12}>
            <ul className="mt-8 space-y-3.5">
              {[
                "The fee doesn't change whether you run one asset or ten.",
                "Same process. Same deliverables. Same seven-day timeline.",
                "Track record: $185.9M identified, $127.7M realized.",
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-[#3c4a58] text-[15.5px]">
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-[#0E5F46]/10 flex items-center justify-center shrink-0">
                    <Check className="w-3 h-3 text-[#0E5F46]" strokeWidth={3} />
                  </span>
                  {t}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 flex items-center gap-4 p-5 rounded-2xl bg-[#f7f9fa] border border-[#0B1B2B]/8 max-w-[440px]" data-testid="lead-headshot-card">
              <img
                src="/images/headshot.jpg"
                alt="Engagement lead portrait"
                loading="lazy"
                className="w-16 h-16 rounded-full object-cover border-2 border-white shadow-[0_4px_14px_rgba(11,27,43,0.15)]"
              />
              <div>
                <p className="font-display font-bold text-[#0B1B2B] text-[15px]">Every diagnostic is led by a senior operator.</p>
                <p className="mt-1 text-[#3c4a58] text-[13px]">Executives who have run manufacturing businesses — not junior analysts.</p>
              </div>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="p-9 lg:p-12 rounded-3xl bg-[#0E5F46] text-white relative overflow-hidden" data-testid="guarantee-card">
            <div className="absolute -right-14 -top-14 w-56 h-56 rounded-full bg-white/[0.07]" />
            <div className="absolute -right-4 -top-4 w-32 h-32 rounded-full bg-white/[0.07]" />
            <p className="text-[13px] uppercase tracking-[0.2em] font-bold text-[#a9e8d0]">The Guarantee</p>
            <p className="mt-5 font-display font-extrabold text-2xl sm:text-3xl lg:text-[34px] leading-tight">
              We find at least 10x our fee in recoverable cash — or you don't pay.
            </p>
            <p className="mt-5 text-white/90 text-[15px] leading-relaxed">
              That's backed by the three cases above and the five-pillar framework that produced them.
            </p>
            <CtaButton testId="investment-cta-button" invert className="mt-8">Book a 20-minute Discovery call</CtaButton>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
